export default "__VITE_ASSET__HJqFw_N5__"